export default {
      id: "ic_google_play-usage",
      viewBox: "0 0 404 120",
      url: "/" + "images/icons.3.109.2.svg#ic_google_play-usage",
      toString: function () {
        return this.url;
      }
    }